export const TYPES = {
  warning: { id: 'warning', label: 'Warning' },
  alarm: { id: 'alarm', label: 'Alarm' },
};

export const TYPES_ARRAY = [
  TYPES.warning,
  TYPES.alarm,
];